import { Link } from "@tanstack/react-router";
import { sanitizeTags, tagLabel } from "@/lib/tags";

/**
 * Tag chips shown under an essay. Curated slugs come from src/lib/tags.ts;
 * editor-authored free tags are shown with a humanised label.
 */
export function TagChips({
  tags,
  lang,
  className = "",
}: {
  tags: readonly string[] | undefined;
  lang: "tr" | "en";
  className?: string;
}) {
  const slugs = sanitizeTags(tags);
  if (slugs.length === 0) return null;
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <span className="text-[10px] uppercase tracking-[0.25em] text-ink/60 mr-1">
        {lang === "tr" ? "Etiketler" : "Tags"}
      </span>
      {slugs.map((slug) => (
        <Link
          key={slug}
          to="/etiket/$slug"
          params={{ slug }}
          className="px-3 py-1.5 rounded-full border border-ink/20 text-[10px] uppercase tracking-[0.2em] font-semibold text-ink/75 hover:border-ink hover:text-ink transition-colors"
        >
          {tagLabel(slug, lang)}
        </Link>
      ))}
    </div>
  );
}

